"use client";

import Image from "next/image";
import { useState } from "react";
import VideoModal from "./VideoModal";

type Section5VideoProps = {
  videoUrl: string;
  backgroundImage?: string;
};

export default function Section5Video({
  videoUrl,
  backgroundImage,
}: Section5VideoProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="relative overflow-hidden">
        {/* BACKGROUND */}
        <div className="absolute inset-0 z-0">
          {backgroundImage ? (
            <Image
              src={backgroundImage}
              alt=""
              fill
              className="object-cover"
              priority
            />
          ) : (
            <div className="w-full h-full bg-primary" />
          )}
        </div>

        {/* CONTENT */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 md:pt-24">
          <div className="relative aspect-video max-w-6xl mx-auto rounded-2xl overflow-hidden shadow-2xl">
            {/* IFRAME PREVIEW */}
            <iframe
              src={videoUrl}
              title="Video preview"
              className="absolute inset-0 w-full h-full pointer-events-none"
            />

            {/* OVERLAY */}
            <div className="absolute inset-0 bg-black/20" />

            {/* FULLSCREEN BUTTON */}
            <button
              type="button"
              aria-label="Open video fullscreen"
              onClick={() => setOpen(true)}
              className="
                absolute right-4 bottom-4
                z-10
                flex items-center justify-center
                w-12 h-12
                rounded-full
                bg-black/70
                text-white text-xl
                hover:bg-black
                transition
              "
            >
              ⛶
            </button>
          </div>
        </div>
      </section>

      <VideoModal
        open={open}
        onClose={() => setOpen(false)}
        videoUrl={videoUrl}
      />
    </>
  );
}
